export default __webpack_public_path__ + "static/media/Month.4fed2c7a.svg";